import { ReactElement, useState } from "react";
import { TextInput } from "../TextInput/TextInput";
import { SecretValue } from "client/Api/Apps/common";
import { ControlAttachmentOptions } from "../ControlAttachment";

export type SecretValueInputProps = {
	value: SecretValue;
	attachedOn?: ControlAttachmentOptions;
	containsInitialValue?: boolean;
	isInvalid?: boolean;
	onBlur?(value: SecretValue): void;
	placeholder?: string;
	trackingId?: string;
} & ({ onChange(value: SecretValue): void; isDisabled?: boolean; } | { isDisabled: true; onChange?(value: SecretValue): void; });

const VALUE_FILLER: string = "**************************";

export const SecretValueInput = (props: SecretValueInputProps): ReactElement => {
	const {
		value,
		attachedOn,
		onChange,
		containsInitialValue = false,
		isInvalid,
		isDisabled = false,
		onBlur,
		placeholder,
		trackingId
	} = props;

	const [hasFocus, setHasFocus] = useState<boolean>(false);

	const changeHandler = (value: string): void => {
		if (!onChange) {
			return;
		}

		onChange({
			containsNewValue: true,
			value
		});
	};

	const blurHandler = (newValue: string): void => {
		setHasFocus(false);

		if (onBlur) {
			onBlur({
				containsNewValue: value.containsNewValue,
				value: newValue
			});
		}
	};

	const valueToRender: string | null = value.containsNewValue
		? value.value
		: containsInitialValue && !hasFocus
			? VALUE_FILLER
			: "";

	return (
		<TextInput
			type="password"
			value={valueToRender ?? ""}
			placeholder={placeholder}
			onChange={changeHandler}
			onFocus={() => setHasFocus(true)}
			onBlur={blurHandler}
			isInvalid={isInvalid}
			isDisabled={isDisabled}
			attachedOn={attachedOn}
			trackingId={trackingId}
		/>
	);
};
SecretValueInput.displayName = "SecretValueInput";
